import store from '@/store';
import mixpanel from 'mixpanel-browser';
export const useMixpanelCultureReportSort = (pageViewName, column, order) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        column,
        order,
    });
};
export const useMixpanelCultureReportExport = (pageViewName, typeFile, table, dates, query) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        typeFile,
        table,
        dates,
        query: JSON.stringify(query),
    });
};
export const useMixpanelCultureReportSearch = (pageViewName, column, value) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        column,
        value,
    });
};
export const useMixpanelCultureReportSelectedTable = (pageViewName, table) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        table,
    });
};
